// Central SEO constants + helpers for USAPulse (client-side, react-helmet-async).
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://usapulse.net").replace(/\/$/, "");
export const HOMES_URL = (process.env.REACT_APP_HOMES_URL || "https://homespulse.pro").replace(/\/$/, "");
export const SITE_NAME = "USAPulse.net";
export const DEFAULT_DESC =
  "USAPulse is a living digital knowledge network for the United States — explore every state, county, city and town with its people, history, culture, economy and local pulse.";
export const DEFAULT_IMAGE = `${SITE_URL}/og-default.jpg`;

// Build an absolute canonical URL from a path. Homes routes use the HomesPulse domain.
export function canonicalUrl(path = "/") {
  const p = path.startsWith("/") ? path : `/${path}`;
  const base = p.startsWith("/homes") ? HOMES_URL : SITE_URL;
  return `${base}${p === "/" ? "" : p}`;
}

export function truncate(str, n = 160) {
  if (!str) return "";
  const clean = String(str).replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
  return clean.length > n ? `${clean.slice(0, n - 1).trimEnd()}…` : clean;
}

// Organization + WebSite (with SearchAction sitelinks searchbox) for the home page.
export function orgAndWebsiteJsonLd() {
  return [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: SITE_NAME,
      url: SITE_URL,
      logo: `${SITE_URL}/logo512.png`,
      sameAs: [],
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: SITE_NAME,
      url: SITE_URL,
      potentialAction: {
        "@type": "SearchAction",
        target: { "@type": "EntryPoint", urlTemplate: `${SITE_URL}/search?q={search_term_string}` },
        "query-input": "required name=search_term_string",
      },
    },
  ];
}

// BreadcrumbList JSON-LD from [{name, url_path}] items (url_path relative, will be made absolute).
export function breadcrumbJsonLd(items = []) {
  if (!items.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: canonicalUrl(it.url_path || "/"),
    })),
  };
}

// ItemList JSON-LD for directory pages (e.g. all cities in a state).
export function itemListJsonLd(name, items = []) {
  if (!items.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name,
    numberOfItems: items.length,
    itemListElement: items.slice(0, 200).map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      url: canonicalUrl(`/place${it.url_path}`),
    })),
  };
}
